const styles = theme => ({
  root: {
    display: 'flex',
    gap: 16,
    justifyContent: 'center',
  },
  container: {
    maxWidth: '800px',
    width: '100%',
    display: 'flex',
    gap: 16,
    flexDirection: 'column',
  },
  input: {
    backgroundColor: '#fff',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 16,
    boxShadow:
      '0px 0px 2px rgba(145,158,171,0.12), 0px 12px 24px -4px rgba(145,158,171,0.12)',
    overflow: 'hidden',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  headerTitle: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 14,
    color: '#002E47',
  },
  divider: {
    height: 1,
    backgroundColor: '#E5E7EB',
    width: '100%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionLabel: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 14,
    color: '#002E47',
    padding: '16px 24px 8px',
    display: 'block',
  },
  sectionPadded: {
    padding: '0 24px 16px',
  },
  accordionWrapper: {
    margin: '0 24px 16px',
    border: '1px solid #E5E7EB',
    borderRadius: 12,
    overflow: 'hidden',
  },
  badgeImageWrapper: {
    padding: '0 24px 24px',
  },
})

export default styles
